/** @name RCDPW.validator.rules.requestInv */
RCDPW.module('RCDPW.validator.rules.requestInv', {
    firstName: 'required',
    lastName: 'required',
    email: {
        required: true,
        customEmailWithBackList: true
    },
    contactPhone: {
        required: true,
        rangelength: [1, 40]
    },
    company: 'required',
    expectedUsers: {
        required: true,
        digits: true,
        min: 1,
        rangelength: [1, 9]
    },
    websiteUrl: 'required',
    description: 'required'
});